/**
 * Optimizes image URLs for better performance by adding resize/format parameters.
 * Supports Supabase Storage and Unsplash URLs.
 */

const SUPABASE_STORAGE_PREFIX = 'tbljtxwglebvhjxzjqod.supabase.co/storage/v1/object/public/';

export function getOptimizedImageUrl(url: string, width: number, quality = 75): string {
  if (!url) return url;

  // Unsplash: use their built-in image CDN params
  if (url.includes('images.unsplash.com')) {
    const separator = url.includes('?') ? '&' : '?';
    return `${url}${separator}w=${width}&q=${quality}&fm=webp&fit=crop`;
  }

  // Supabase Storage: use render/image transform endpoint
  if (url.includes(SUPABASE_STORAGE_PREFIX)) {
    // Transform: /storage/v1/object/public/bucket/path → /storage/v1/render/image/public/bucket/path
    const transformed = url.replace(
      '/storage/v1/object/public/',
      '/storage/v1/render/image/public/'
    );
    const separator = transformed.includes('?') ? '&' : '?';
    return `${transformed}${separator}width=${width}&quality=${quality}`;
  }

  return url;
}

/**
 * Generates a srcSet string for responsive images.
 */
export function getImageSrcSet(url: string, widths: number[] = [400, 800, 1200]): string {
  if (!url) return '';

  // Only generate srcSet for supported CDNs
  if (!url.includes('images.unsplash.com') && !url.includes(SUPABASE_STORAGE_PREFIX)) {
    return '';
  }

  return widths
    .map(w => `${getOptimizedImageUrl(url, w)} ${w}w`)
    .join(', ');
}
